import React, { useEffect } from 'react'
import LayoutDetail from 'tennders-stracture/layouts/old-views/LayoutDetail'
import TransactionContent from 'tennders-transactions/components/TransactionContent'
import { useRouter } from 'next/router'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import TransactionHeader from 'tennders-transactions/components/TransactionHeader'

const TransactionView = () => {
  const router = useRouter()
  const tId = router.query?.tId
  const assignType = router.query?.assign
  const { openTransaction } = useTransaction()

  useEffect(() => {
    if (tId) {
      openTransaction(tId, assignType)
    }
  }, [tId])

  return (
    <LayoutDetail
      id={tId}
      header={<TransactionHeader />}
    >
      <TransactionContent />
    </LayoutDetail>
  )
}

export default TransactionView
